module.exports = __webpack_public_path__ + "img/garage-arbor.078fa7da.webp";